import getNestedPropByID from "../../../../functions/getNestedPropByID";

function ConsultantInvoicesTable({
  Arr_Invoices,
  obj_EC,
  Arr_ECs,
  getAttendeeNames,
}) {
  return (
    <div
      style={{
        overflowX: "scroll",
        overflowY: "auto",
        maxHeight: "calc(100vh - 300px)",
      }}
    >
      <table id="BookingTable">
        <thead>
          <tr>
            <th>Invoice Number</th>
            <th>Students</th>
            <th>
              Create Date <i>(dd/mm/yy)</i>
            </th>
            <th>
              Due Date <i>(dd/mm/yy)</i>
            </th>
            <th>Amount</th>
            <th>
              Paid Date <i>(dd/mm/yy)</i>
            </th>
            <th>Invoice Status</th>
            <th>Link</th>
          </tr>
        </thead>
        <tbody>
          {Arr_Invoices.map((obj_invoice, index) => (
            <>
              <tr key={index}>
                <td>{obj_invoice.Invoice_Number || ""}</td>
                <td>{getAttendeeNames(obj_invoice) || ""}</td>

                <td>
                  {obj_invoice.DateTime
                    ? obj_invoice.DateTime.substring(8, 10) +
                      "/" +
                      obj_invoice.DateTime.substring(5, 7) +
                      "/" +
                      obj_invoice.DateTime.substring(2, 4)
                    : ""}
                </td>
                <td>
                  {obj_invoice.Due_Date
                    ? obj_invoice.Due_Date.substring(8, 10) +
                      "/" +
                      obj_invoice.Due_Date.substring(5, 7) +
                      "/" +
                      obj_invoice.Due_Date.substring(2, 4)
                    : ""}
                </td>
                <td>{obj_invoice.Amount ? "£" + obj_invoice.Amount : ""}</td>
                {obj_invoice.Paid_Date ? (
                  <td>
                    {obj_invoice.Paid_Date.substring(8, 10)}/
                    {obj_invoice.Paid_Date.substring(5, 7)}/
                    {obj_invoice.Paid_Date.substring(2, 4)}
                  </td>
                ) : (
                  <td style={{ backgroundColor: "grey" }}></td>
                )}
                {obj_invoice.Paid_Status === "Paid" ? (
                  <td style={{ backgroundColor: "#DAF7A6" }}>Paid</td>
                ) : (
                  <td style={{ backgroundColor: "#85c1e9" }}>UnPaid</td>
                )}
                {obj_invoice.Paid_Status === "Paid" ? (
                  <td></td>
                ) : obj_invoice.Link && obj_invoice.Link.length > 0 ? (
                  <td>
                    <button
                      onClick={() => window.open(obj_invoice.Link, "_blank")}
                    >
                      Payment Link
                    </button>
                  </td>
                ) : (
                  <></>
                )}
              </tr>
            </>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default ConsultantInvoicesTable;
